export default
[
    {
        "title":"لدينا خبراء فى ميكانيكا السيارات",
        "semiTitle":"خبرة أكثر من 20 عام",
        "src":"https://mhesham32cdn.netlify.com/img/elmohandess/slides/steel.jpg",
        "index":0,
        "hasButton":false,
        "className":"motor-slide",
        "startClass":"animated fadeInDown",
        "endClass":"animated fadeOutClass",
        "classes":[
            "animated fadeIn",
            "animated fadeInDown"
        ]
    },
    {
        "title":"أفضل وأشهر أنواع الزيوت",
        "classes":[
            "animated fadeIn",
            "animated fadeInDown"
        ],
        "semiTitle":"لدينا أفضل زيوت المحركات",
        "src":"https://mhesham32cdn.netlify.com/img/elmohandess/slides/motor-oil.jpg",
        "index":1,
        "hasButton":false,
        "className":"no-slide",
        "startClass":"animated fadeIn",
        "endClass":"animated fadeOutClass"
    },
    {
        "title":"أفضل وأشهر أنواع الزيت",
        "classes":[
            "animated fadeIn",
            "animated fadeInDown"
        ],
        "semiTitle":"لدينا أفضل زيوت المحركات",
        "src":"https://mhesham32cdn.netlify.com/img/elmohandess/slides/card.jpg",
        "index":2,
        "hasButton":true,
        "className":"motor-slide",
        "startClass":"animated fadeInDown",
        "endClass":"animated fadeOutClass"
    },
    {
        "title":"لدينا مهندسيين وعمال على أعلى مستوى",
        "classes":[
            "animated fadeIn",
            "animated fadeInDown"
        ],
        "semiTitle":"خبرة أكثر من 20 عام",
        "src":"https://mhesham32cdn.netlify.com/img/elmohandess/slides/mechanic.jpg",
        "index":3,
        "hasButton":false,
        "className":"motor-slide",
        "startClass":"animated fadeIn",
        "endClass":"animated fadeOutClass"
    }
];


// WEBPACK FOOTER //
// ./src/data/carouselData.js